import React from 'react';
import { motion } from 'framer-motion';
import { Star, MapPin, CalendarCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Hero() {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden" data-id="element-110">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 rounded-full bg-sage-100/50 blur-3xl -z-10" data-id="element-111"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 rounded-full bg-coral-100/40 blur-3xl -z-10" data-id="element-112"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-113">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-114">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-115">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-sage-50 text-sage-700 font-medium text-sm mb-6 border border-sage-100" data-id="element-116">
              <Star size={16} className="fill-sage-500 text-sage-500" data-id="element-117" />
              <span data-id="element-118">Serving Lincoln &amp; Waverly since 2001</span>
            </div>

            <h1 className="text-5xl lg:text-6xl xl:text-7xl font-serif leading-[1.05] mb-6 text-charcoal-800" data-id="element-119">
              We go the <span className="text-sage italic" data-id="element-120">extra smile</span>.
            </h1>

            <p className="text-lg lg:text-xl text-charcoal-500 mb-8 leading-relaxed max-w-lg" data-id="element-121">
              Dr. Dennis Martin and our team provide family-oriented dental care
              that puts your well-being above all else — with the highest level
              of care in a relaxed, inviting atmosphere.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-12" data-id="element-122">
              <Link to="/appointments" className="bg-sage hover:bg-sage-600 text-white px-8 py-4 rounded-full font-medium text-lg text-center transition-all hover:shadow-lg hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-sage focus-visible:ring-offset-2 focus-visible:ring-offset-cream" data-id="element-123">
                Book Appointment
              </Link>
              <a href="#services" className="bg-white hover:bg-sage-50 text-charcoal-700 border border-sage-200 px-8 py-4 rounded-full font-medium text-lg text-center transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-sage focus-visible:ring-offset-2 focus-visible:ring-offset-cream" data-id="element-124">
                Our Treatments
              </a>
            </div>

            <div className="flex items-center gap-8 pt-6 border-t border-sage-100" data-id="element-125">
              <div className="flex items-center gap-3" data-id="element-126">
                <div className="bg-coral-50 p-3 rounded-full text-coral" data-id="element-127">
                  <MapPin size={24} data-id="element-128" />
                </div>
                <div data-id="element-129">
                  <p className="font-bold text-charcoal-800 text-lg leading-tight" data-id="element-130">
                    2 Offices
                  </p>
                  <p className="text-sm text-charcoal-500 font-medium" data-id="element-131">
                    Lincoln &amp; Waverly
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3" data-id="element-132">
                <div className="bg-sage-50 p-3 rounded-full text-sage" data-id="element-133">
                  <CalendarCheck size={24} data-id="element-134" />
                </div>
                <div data-id="element-135">
                  <p className="font-bold text-charcoal-800 text-lg leading-tight" data-id="element-136">
                    20+ Years
                  </p>
                  <p className="text-sm text-charcoal-500 font-medium" data-id="element-137">
                    Caring for Nebraska
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative lg:ml-auto" data-id="element-138">
            <div className="relative rounded-[2rem] overflow-hidden shadow-soft aspect-[4/5] max-w-md mx-auto lg:max-w-none" data-id="element-139">
              <img src="https://images.unsplash.com/photo-1629909613654-28e377c37b09?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Modern, bright dental treatment room" className="w-full h-full object-cover" data-id="element-140" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal-900/40 to-transparent" data-id="element-141"></div>

              {/* Floating new patient special card */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.8
            }} className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm p-5 rounded-2xl shadow-lg" data-id="element-142">
                <div className="flex items-center justify-between gap-4" data-id="element-143">
                  <div data-id="element-144">
                    <p className="text-xs font-semibold tracking-wider uppercase text-coral mb-1" data-id="element-145">
                      New Patient Special
                    </p>
                    <p className="text-sm text-charcoal-700 font-medium leading-snug" data-id="element-146">
                      Exam, 4 BW X-rays &amp; cleaning — just mention this
                      website.
                    </p>
                  </div>
                  <div className="shrink-0 text-right" data-id="element-147">
                    <p className="font-serif text-3xl font-semibold text-sage leading-none" data-id="element-148">
                      $69
                    </p>
                  </div>
                </div>
              </motion.div>
            </div>

            {/* Decorative dots */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-[radial-gradient(#3B8A82_2px,transparent_2px)] [background-size:12px_12px] opacity-20 -z-10" data-id="element-149"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}